module.exports = __webpack_public_path__ + "static/media/PHBA-Blue-Crew-Logo.ba706c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PHBA-Blue-Crew-Logo.png
// module id = 830
// module chunks = 0